import { render } from "./UserPrivacyByCode.vue?vue&type=template&id=6e342a1c&scoped=true&ts=true"
import script from "./UserPrivacyByCode.vue?vue&type=script&lang=ts"
export * from "./UserPrivacyByCode.vue?vue&type=script&lang=ts"

import "./UserPrivacyByCode.vue?vue&type=style&index=0&id=6e342a1c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e342a1c"]])

export default __exports__